<div class="body">
    <br/>
    <!-- 
    <div class="container principal">
        <div class="col-lg-12">
            <p> A contar del día <b>MIERCOLES 05 DE MAYO DE 2021 </b>, el Servicio de Bienestar ha suscrito un Contrato de Seguro Colectivo de Vida y Complementario de Salud.
                <br/>
                <br/> Esto significa que <b> seguiremos usando la Plataforma de Reembolso Médicos de Bienestar</b>, pero los porcentajes que se aplicarán al reembolso de beneficios estarán determinados por la fecha de emisión de los documentos y, por
                ende, podrían sufrir variación.
            </p>
            <br/>
        </div>
    </div>
    -->
    <!-- 
    <div class = "container principal">
        <div class = "col-lg-12"> 
          <p>Circular N° 3623 de fecha 18.10.2021, Superintendencia de Seguridad Social. <b>Los afiliados deben conservar los originales de los documentos </b>
           <br/>
           <b>de respaldo de los beneficios solicitados digitalmente al Servicio de Bienestar, por el plazo de 5 años</b>
           <br/>
           <b> conforme a los Artículos N° 2514 y 2515 del Código Civil.</b>  Dictamen N° 467/2021. 
          </p>         
           <br/>       
        </div>
    </div>
     --> 
    <div class = "container principal">
        <div class = "col-lg-12" style="font: 400 18px/20px Roboto">  
          <p>Según lo indicado por la SUSESO, <b>los afiliados deben conservar los originales de los documentos de respaldo de los </b>
           <br/>
           <b>beneficios solicitados digitalmente al Servicio de Bienestar, por el plazo de 5 años</b> (Circular N°3623 de fecha 18.10.2021)
           <br/>
           <br/>
           La adulteración de datos y/o documentos contables constituye una falta grave a la probidad lo cual 
           conlleva expulsión total del Servicio de Bienestar y el inicio inmediato de una investigación o sumario  administrativo.   
           <br/>
           <br/>
           Por otro lado, le recordamos que a contar del 05-05-2025 y hasta el 04-05-2027 los reembolsos médicos son gestionados por cía. de seguros Vida Cámara.
           </p>  
           <p><b>Manual de Reembolso: </b> <a href="{{this.linkTexto}}" target="_blank">
            Reembolso</a>.</p>            
           <br/>       
        </div>
    </div>

    


    <div class="container" style="height:50px"> </div>

    <div class="container principal">

        <div *ngIf="rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO'">

            <div class="row">

                <div class="col-lg-8"> </div>

                <div class="col-lg-4">
                    <p> <b> Usuario: </b> {{nombreUsuario}} </p>
                </div>

            </div>

        </div>



        <div *ngIf="rol != 'ROLE_AFILIADO'" style="padding-bottom: 20px;">

            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-2">
                    <h1> Rut Afiliado </h1>
                </div>

                <div class="col-lg-6">

                    <input id="txt_rut" name="afiliado" [(ngModel)]="reembolso.afiliado" #afiliado="ngModel" class="form-control" type="text" required placeholder="Ingrese el RUT del afiliado. Ej: 11111111-1" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1">

                    <button class="btn btn-primary" id="btnvalida" (click)="ingresaAfiliado()" [disabled]="afiliado.invalid">

                        Buscar

                    </button>

                </div>

                <div class="col-lg-1"> </div>

            </div>

        </div>

        <div class="row">

            <div class="col-lg-1"> </div>

            <div class="col-lg-4">
                <h1> Reembolsos </h1>
            </div>

            <div class="col-lg-4"> </div>

        </div>

        <hr/> <br/>

        <div class="row">

            <div class="col-lg-1"> </div>

            <div class="col-lg-2"> <label>Tipo de Reembolso</label> </div>

            <div class="col-lg-8">

                <div class="form-group">

                    <select id="tipoBeca" name="tipoBeca" class="form-control" required [(ngModel)]="reembolso.tipoReembolso" #tipoBeca="ngModel" (change)="seleccionaTipoReembolso()">

                        <option *ngFor = "let tipo of tiposReembolso" value = {{tipo.id}}> {{tipo.descripcion}} </option>

                    </select>

                </div>

                <div *ngIf="tipoBeca.errors && tipoBeca.touched" class="alert alert-danger">

                    <div *ngIf="tipoBeca.errors.required"> Seleccione Tipo de Reembolso. </div>

                </div>

            </div>

        </div> <br/> <br/>

        <form #reembolsoForm=ngForm>

            <div class="table-responsive">

                <table class="table">

                    <thead style="background-color: #0f69b4;color:white;">

                        <tr>
                            <th scope="col"> Rut </th>

                            <th scope="col"> Nombre y Apellido </th>

                            <th scope="col"> Parentesco </th>

                            <th scope="col"> Edad </th>

                            <th scope="col"> Sexo </th>

                            <th scope="col"> Seleccionar </th>
                        </tr>

                    </thead>

                    <tbody>

                        <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let postulante of postulantes; let i = index">

                            <td> {{postulante.rut + '-' + postulante.dv}} </td>

                            <td> {{postulante.nombres + ' ' + postulante.apellidoPaterno }} </td>

                            <td> {{postulante.parentesco}} </td>

                            <td> {{postulante.fechaNacimiento}} </td>

                            <td> {{postulante.sexo.nombre}} </td>

                            <td>

                                <input type="radio" name="postulante" [(ngModel)]="reembolso.beneficiario" value="{{i}}" required>

                            </td>

                        </tr>

                    </tbody>

                </table>

            </div> <br/> <br/>

            <div class="row">

                <div class="col-lg-1 col-xs-1"> </div>

                <div class="col-lg-3 col-xs-5">
                    <h2> Datos de Reembolso </h2>
                </div>

                <div class="col-lg-1 col-xs-5"> </div>

            </div> <br/>

            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3"> <label> Categoría de Prestación </label> </div>

                <div class="col-lg-5">

                    <div class="form-group">

                        <select name="categoriaPrestacion" class="form-control" required [(ngModel)]="reembolso.categoriaPrestacion" #categoriaPrestacion="ngModel" (change)="seleccionaCategoria()">

                            <option *ngFor = "let categoria of categorias" value = "{{categoria.id}}">

                                {{categoria.descripcion}}

                            </option>

                        </select>

                    </div>

                    <div *ngIf="categoriaPrestacion.errors && categoriaPrestacion.touched" class="alert alert-danger">

                        <div *ngIf="categoriaPrestacion.errors.required"> Seleccione Categoría de Prestación. </div>

                    </div>

                </div>

                <div class="col-lg-3"> </div>

            </div> <br/>

            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3"> <label> SubCategoría de Prestación </label> </div>  

                <div class="col-lg-5">

                    <div class="form-group">
                       
                        <mat-select name="subCategoriaPrestacion" class="form-control" required ngSelected="" [(ngModel)]="reembolso.subCategoriaPrestacion" #subCategoriaPrestacion="ngModel" (selectionChange)="logicaCapacidadDescuento($event)">

                            <mat-option *ngFor = "let subcategoria of subcategorias; let i = index" value = "{{i}}">

                                {{subcategoria.descripcion}}

                            </mat-option>

                        </mat-select>

                    </div>

                    <div *ngIf="subCategoriaPrestacion.errors && subCategoriaPrestacion.touched" class="alert alert-danger">

                        <div *ngIf="subCategoriaPrestacion.errors.required"> Seleccione SubCategoría de Prestación. </div>

                    </div>

                </div>

                <div class="col-lg-3"> </div>

            </div> <br/>

            <div *ngIf="mostrarCapacidadReembolso" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Monto disponible para reembolso</p>
                </div>

                <div class="col-lg-5">

                    <input id="capacidad" name="capacidad" [(ngModel)]="reembolso.capacidad" #capacidad="ngModel" class="form-control" readonly type="text" placeholder="0" 
                    />

                </div>
               

            </div>  <br/>

            <div class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Rut Prestador </p>
                </div>

                <div class="col-lg-5">

                    <input id="txt_rutPrestador" name="rutPrestador" [(ngModel)]="reembolso.rutPrestador" #rutPrestador="ngModel" class="form-control" type="text" required type="text" placeholder="Ingrese el RUT del prestador. Ej: 11111111-1" pattern="[0-9]{7,10}[-]{1}[0-9Kk]{1}"
                    />

                </div>
                <div *ngIf="!rutPrestador.errors?.pattern" class="col-lg-3"> </div>
                <div *ngIf="rutPrestador.errors?.pattern" class="alert alert-danger">

                    <div> RUT del prestador. Ej: 11111111-1 </div>

                </div>

            </div>


            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3"> <label> Tipo de Documento </label> </div>

                <div class="col-lg-5">

                    <div class="form-group">

                        <select name="tipoDocumento" class="form-control" required [(ngModel)]="reembolso.tipoDocumento" #tipoDocumento="ngModel">

                            <option *ngFor = "let tipoDocumento of tiposDocumento" value = "{{tipoDocumento}}">

                                {{tipoDocumento}}

                            </option>

                        </select>

                    </div>

                    <div *ngIf="tipoDocumento.errors && tipoDocumento.touched" class="alert alert-danger">

                        <div *ngIf="tipoDocumento.errors.required"> Seleccione Tipo de Documento. </div>

                    </div>

                </div>

            </div>

            <div class="col-lg-3"> </div>

            <br/>

            <div class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Fecha Documento </p>
                </div>

                <div class="col-lg-5">

                    <input class="form-control" name="fechaDocumento" required #diagnostico="ngModel" [(ngModel)]="reembolso.fechaDocumento" type="date">

                </div>

                <div class="col-lg-3"> </div>

            </div>

            <div class="row line">

                <div class="col-lg-1"> </div>


                <div class="col-lg-3">
                    <p> Folio de Documento </p>
                </div>


                <div class="col-lg-5">

                    <input class="form-control" name="nDocumento" required #nDocumento="ngModel" [(ngModel)]="reembolso.nDocumento" type="text" (keypress)="numberOnly($event)" autocomplete=off onPaste="return false">

                </div>

                <div class="col-lg-3"> </div>

            </div>

            <div class="row line">

                <div class="col-lg-1"> </div>


                <div class="col-lg-3">
                    <p> Folio de Respaldo (N° de Boleta, N° de Voucher, otros) En caso de no contar con respaldo, indicar 0 (cero) </p>
                </div>


                <div class="col-lg-5">

                    <input class="form-control" name="nBoleta" required #nBoleta="ngModel" [(ngModel)]="reembolso.nBoleta" type="text" (keypress)="numberOnly($event)" autocomplete=off onPaste="return false">

                </div>

                <div class="col-lg-3"> </div>

            </div>

            <div class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Monto Copago </p>
                </div>

                <div class="col-lg-5">

                    <input class="form-control" name="montoCopago" required #montoCopago="ngModel" [(ngModel)]="reembolso.montoCopago" type="text" (keypress)="numberOnly($event)" autocomplete=off onPaste="return false">

                </div>

                <div class="col-lg-3"> </div>

            </div>

            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3"> <label> Cobertura de Sistema de Salud </label> </div>

                <div class="col-lg-5">

                    <div class="form-group">

                        <select name="prevision" class="form-control" required [(ngModel)]="reembolso.prevision" #prevision="ngModel">

                            <option *ngFor = "let prevision of previsiones" value = "{{prevision.id}}">

                                {{prevision.nombre}}

                            </option>

                        </select>

                    </div>

                    <div *ngIf="prevision.errors && prevision.touched" class="alert alert-danger">

                        <div *ngIf="prevision.errors.required"> Seleccione Previsión. </div>

                    </div>

                </div>

            </div> <br/>

            <div *ngIf="mostrarArchivosDentales" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3 col-xs-5">
                    <h2> Adjuntar documentos: </h2>
                </div>

                <div class="col-lg-5">                 
                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> </div>

            </div>
            
            <div *ngIf="mostrarArchivosDentales" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p><b> {{descripcion1}} </b></p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo0" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="reembolso.archivoTest0" (change)="seleccionaArchivo($event, 0)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo(mostrarArchivosDentales)"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>

            <div *ngIf="mostrarArchivosDentales" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p><b> {{descripcion2}} </b></p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo1" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="reembolso.archivoTest1" (change)="seleccionaArchivo($event, 1)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo(mostrarArchivosDentales)"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>

            <div *ngIf="mostrarArchivosDentales" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p><b> {{descripcion3}} </b></p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo2" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="reembolso.archivoTest2" (change)="seleccionaArchivo($event, 2)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo(mostrarArchivosDentales)"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>

            <div *ngIf="mostrarArchivosDentales"class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo3"  accept="application/pdf, image/jpeg, image/jpg" [(ngModel)]="reembolso.archivoTest3" (change)="seleccionaArchivo($event, 3)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo(mostrarArchivosDentales)"> + </button> </div>

                <div class="col-lg-1"> </div>

            </div>

            <div *ngIf="mostrarArchivosDentales && cantidadArchivos > 3" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (5) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo4"  accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="reembolso.archivoTest4" (change)="seleccionaArchivo($event, 4)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo(mostrarArchivosDentales)"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>


            <div *ngIf="mostrarArchivosDentales && cantidadArchivos > 4" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (6) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo5"  accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="reembolso.archivoTest5" (change)="seleccionaArchivo($event, 5)">

                </div>

                <div class="col-lg-2"> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>
            


            <div *ngIf="mostrarArchivosDentales == false"class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo" required accept="application/pdf, image/jpeg, image/jpg" [(ngModel)]="reembolso.archivoTest" (change)="seleccionaArchivo($event, 0)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo(mostrarArchivosDentales)"> + </button> </div>

                <div class="col-lg-1"> </div>

            </div>

            <div *ngIf="mostrarArchivosDentales==false && cantidadArchivos > 1" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (2) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo2" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="reembolso.archivoTest2" (change)="seleccionaArchivo($event, 1)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo(mostrarArchivosDentales)"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>      
            <div *ngIf="mostrarArchivosDentales==false &&cantidadArchivos > 2" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (3) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo3" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="reembolso.archivoTest3" (change)="seleccionaArchivo($event, 2)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo(mostrarArchivosDentales)"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>

            <div *ngIf="mostrarArchivosDentales==false &&cantidadArchivos > 3" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (4) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo4" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="reembolso.archivoTest4" (change)="seleccionaArchivo($event, 3)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo(mostrarArchivosDentales)"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>

            <div *ngIf="mostrarArchivosDentales==false &&cantidadArchivos > 4" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (5) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo5" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="reembolso.archivoTest5" (change)="seleccionaArchivo($event, 4)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo(mostrarArchivosDentales)"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>

            <div *ngIf="mostrarArchivosDentales==false &&cantidadArchivos > 5" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (6) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo6" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="reembolso.archivoTest6" (change)="seleccionaArchivo($event, 5)">

                </div>

                <div class="col-lg-2"> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>

            <br/>
            <div class="row line">

                <div class="col-lg-2 col-sm-2"> </div>

                <div class="col-lg-6 col-sm-1"> <button class="btn btn-danger" (click)="salir()"> Salir </button> </div>


                <div class="col-lg-3 col-sm-1">
                    <div *ngIf="rol != 'ROLE_EJECUTIVO_CAIP' && rol != 'ROLE_ENCARGADO_CONTABILIDAD'">
                        <button class="btn btn-success" (click)="solicitar(reembolsoForm)" [disabled]="reembolsoForm.invalid || procesando">

                            Solicitar

                        </button>
                    </div>
                </div>

                <div class="col-lg-1 col-sm-1"> </div>

            </div>

        </form>

    </div>

    <div class="container" style="height:100px"> </div>

</div>